import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Employee } from '~/types';
import { cleanupFormValues } from '~/utils';
import EmployeeForm from './EmployeeForm';
import { employees } from '~/routes';
import { FormDrawer } from '~/components';
import { usePermissions } from '~/hooks';
import { useEmployeesCreate } from '~/hooks/employees';

const CreateEmployee: FC<any> = () => {
  const [t] = useTranslation('employees');

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate } = useEmployeesCreate(handleClose);

  const onFinish = (values: Employee) => {
    const cleanValues = cleanupFormValues(values);
    if (isEmpty(cleanValues.document)) {
      delete cleanValues.document;
    }
    mutate(cleanValues);
  };

  const hasAccess = usePermissions('business.employee.create');
  if (!hasAccess) return null;
  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {t('addEmployee')}
      </Button>
      <FormDrawer
        name={employees}
        onFinish={onFinish}
        title={t('addEmployee')}
        onClose={handleClose}
        visible={open}
      >
        <EmployeeForm name={employees} />
      </FormDrawer>
    </>
  );
};

export default CreateEmployee;
